const icons = {};
const styles = {
    fill: 'rgba(0, 0, 0, 1)'
};
icons.content = <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100">
<circle cx="50" cy="50" r="40" fill="#FF6978" />
<text x="24" y="70" font-size="60" font-weight="bold" fill="white">M</text>
</svg>



export default icons;
